/*
 * Copyright 2013 The Polymer Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */
(function(scope) {

  var api = {};

  api.declaration = {};
  api.instance = {};

  // exports

  scope.api = api;

})(Polymer);
